export const BATTLE_RANK_COUNT = 7;
export const BATTLE_RANK_LEVELS = 4;
export const BATTLE_RANK_RATING_FLOOR = 1000;
export const BATTLE_RANK_LEVEL_SIZE = 25;
export const BATTLE_RANK_SIZE = BATTLE_RANK_LEVELS * BATTLE_RANK_LEVEL_SIZE;

export type BattleRankDisplay = {
  rating: number;
  rankNumber: number;
  level: number;
  levelsPerRank: number;
  earnedLevels: number;
  rankMinRating: number;
  nextRankMinRating: number | null;
};

const normalizeRating = (ratingRaw: number): number => {
  const rating = Math.floor(Number(ratingRaw));
  if (!Number.isFinite(rating)) return BATTLE_RANK_RATING_FLOOR;
  return Math.max(BATTLE_RANK_RATING_FLOOR, rating);
};

export const getBattleRankDisplay = (ratingRaw: number): BattleRankDisplay => {
  const rating = normalizeRating(ratingRaw);
  const ratingOffset = rating - BATTLE_RANK_RATING_FLOOR;
  const uncappedRankNumber = Math.floor(ratingOffset / BATTLE_RANK_SIZE) + 1;
  const rankNumber = Math.min(BATTLE_RANK_COUNT, Math.max(1, uncappedRankNumber));
  const rankMinRating = BATTLE_RANK_RATING_FLOOR + (rankNumber - 1) * BATTLE_RANK_SIZE;
  const nextRankMinRating =
    rankNumber >= BATTLE_RANK_COUNT ? null : rankMinRating + BATTLE_RANK_SIZE;
  const rankOffset =
    rankNumber >= BATTLE_RANK_COUNT
      ? Math.max(0, rating - rankMinRating)
      : Math.max(0, ratingOffset % BATTLE_RANK_SIZE);
  const level = Math.min(
    BATTLE_RANK_LEVELS,
    Math.max(1, Math.floor(rankOffset / BATTLE_RANK_LEVEL_SIZE) + 1)
  );

  return {
    rating,
    rankNumber,
    level,
    levelsPerRank: BATTLE_RANK_LEVELS,
    earnedLevels: level,
    rankMinRating,
    nextRankMinRating,
  };
};
